import DataGridToolbar from "./DataGridToolbar/DataGridToolbar";
import ResponsiveAppBar from "./ResponsiveAppBar/ResponsiveAppBar";
import StyledIconButton from "./StyledIconButton/StyledIconButton";
import { SelectList } from "./SelectList/SelectList";
import { UserAvatar } from "./UserAvatar/UserAvatar";
import FormLabel from "./FormLabel/FormLabel";
import ButtonGroup from "./ButtonGroup/ButtonGroup";
import TabPanel from "./TabPanel/TabPanel";
import ConfirmationPopup from "./ConfirmationPopup/ConfirmationPopup";
import MainNavBar from "./NavBar/MainNavBar";
import AppCardItem from "./AppCard/AppCardItem";
import AppCardGrid from "./AppCard/AppCardGrid";
import { AppToastMsg, notifyToast, ToastType } from "./AppToastMsg/AppToastMsg";
import { AppDynamicForm } from "./AppDynamicForm/AppDynamicForm";
import PopperMessage from "./PopperMessage/PopperMessage";
import { BackDropLoader } from "./BackDropLoader/BackDropLoader";
import { Modal } from "./Modal/Modal";
import DataGridTable from "./DataGridTable/DataGridTable";
import DataGridRange from "./DataGridRange/DataGridRange";
import TableModal from "./TableModal/TableModal";
import GridRowAction from "./GridRowAction/GridRowAction";
import GridAction from "./GridAction/GridAction";
import DateRangePicker from "./DateRangePicker/DateRangePicker"
import DateRangeFilter from "./DateRangeFilter/DateRangeFilter"
import { PdfViwer } from "./PdfViwer/PdfViwer";

const setBackDropLoader = (isDisplay) => {
  return <BackDropLoader display={isDisplay} />;
};

export {
  UserAvatar,
  SelectList,
  DataGridToolbar,
  ResponsiveAppBar,
  StyledIconButton,
  FormLabel,
  ButtonGroup,
  ConfirmationPopup,
  AppDynamicForm,
  TabPanel,
  AppCardItem,
  AppCardGrid,
  AppToastMsg,
  notifyToast,
  ToastType,
  MainNavBar,
  PopperMessage,
  setBackDropLoader,
  BackDropLoader,
  Modal,
  DataGridTable,
  DataGridRange,
  GridRowAction,
  GridAction,
  DateRangePicker,
  DateRangeFilter,
  PdfViwer,
  TableModal
};
